define(["github:es-shims/es6-shim@0.35.3/es6-shim"], function(main) {
  return main;
});